var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_183_8100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 14,
    height: 14,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 9.59961H14.9L12.8604 7.04998C12.7479 6.90947 12.6053 6.79604 12.4431 6.71808C12.2809 6.64012 12.1032 6.59963 11.9233 6.59961H7.91244C7.42175 6.59961 6.98056 6.8983 6.79831 7.35392L5.9 9.64198C5.38325 9.77586 5 10.241 5 10.7996V12.8996C5 13.0654 5.13425 13.1996 5.3 13.1996H6.2C6.2 14.1937 7.00588 14.9996 8 14.9996C8.99413 14.9996 9.8 14.1937 9.8 13.1996H12.2C12.2 14.1937 13.0059 14.9996 14 14.9996C14.9941 14.9996 15.8 14.1937 15.8 13.1996H16.7C16.8658 13.1996 17 13.0654 17 12.8996V11.3996C17 10.4055 16.1941 9.59961 15.2 9.59961ZM8 14.0996C7.50369 14.0996 7.1 13.6959 7.1 13.1996C7.1 12.7033 7.50369 12.2996 8 12.2996C8.49631 12.2996 8.9 12.7033 8.9 13.1996C8.9 13.6959 8.49631 14.0996 8 14.0996ZM9.35 9.59961H7.19244L7.91244 7.79961H9.35V9.59961ZM10.25 9.59961V7.79961H11.9233L13.3633 9.59961H10.25ZM14 14.0996C13.5037 14.0996 13.1 13.6959 13.1 13.1996C13.1 12.7033 13.5037 12.2996 14 12.2996C14.4963 12.2996 14.9 12.7033 14.9 13.1996C14.9 13.6959 14.4963 14.0996 14 14.0996Z",
    fill: "#F28181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_183_8100",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_8100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_8100",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.d055ba604d606170208531be2808f6f4.svg";
export { ForwardRef as ReactComponent };